import gql from "graphql-tag";

const CREATE_USER = gql`
  mutation createUser($userData: UserInput!) {
    createUser(userData: $userData)
  }
`;

export default CREATE_USER;
